const FLAVOR_OPTION_TYPE_NAME = 'flavor';
const NICOTINE_OPTION_TYPE_NAME = 'nicotine_strength_percent';
const J2_NICOTINE_OPTION_TYPE_NAME = 'temp_j2_nicotine_strength';
const POD_COUNT_OPTION_TYPE_NAME = 'pod_count';

const getOptionValue = (lineItem, typeName) => {
  const options = lineItem.options || [];
  const option = options.find(option => option.type_name === typeName);
  return option ? option.value_presentation : null;
};

export function getFlavor(lineItem) {
  return getOptionValue(lineItem, FLAVOR_OPTION_TYPE_NAME);
}

export function getNicotinePercent(lineItem) {
  return getOptionValue(lineItem, NICOTINE_OPTION_TYPE_NAME);
}
export function getNicotineMilligrams(lineItem) {
  return getOptionValue(lineItem, J2_NICOTINE_OPTION_TYPE_NAME);
}

export function getPodCount(lineItem) {
  return getOptionValue(lineItem, POD_COUNT_OPTION_TYPE_NAME);
}
